import React from "react";
import './Banquite.css';

const BanquiteFacilites = () => {
  const courses = [
    { title: "Spacious Banquet Halls", description: "Elegant, air-conditioned halls perfect for hosting large gatherings, with customizable décor options.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1736781185/1_12_ezznhs.webp",link:"/"  },
    { title: "Outdoor Garden Banquet", description: "A beautiful garden setting for outdoor weddings and events, surrounded by nature.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735894385/2_c8g4co.webp", link: "/management-details" },
    { title: "VIP Lounges", description: "Private, luxurious lounges for special guests to relax and enjoy the event in style.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1736781185/3_10_xlr1mc.webp", link: "/computer-applications-details" },
    { title: "Themed Décor & Customization", description: "A variety of themes and décor options to match your event’s vision, from traditional to contemporary.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735894382/4_tbfolz.webp", link: "/commerce-details" },
    { title: "Stage and Lighting Setup", description: "Professional stage setups with advanced lighting systems for a stunning visual experience..", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735894382/5_rxwqwa.webp", link: "/education-details" },
    { title: "Catering Services", description: "Delicious multi-cuisine catering services with a wide range of menu options for all types of events.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735894382/6_n9vkwl.webp", link: "/pharma-science-details" },
    { title: "Multimedia Support", description: "High-quality audio and visual equipment for presentations, music, and video during events.", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735894383/7_kyio8r.webp", link: "/engineering-details" },
    { title: "Outdoor and Indoor Venue", description: "Flexible venue spaces for both indoor and outdoor events, catering to every type of ceremony or celebration, whether it's a garden wedding or an elegant ballroom affair", image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1736781184/2_7_xe0ncd.webp", link: "/engineering-details" },
  ];

  return (
    <div className="courses-container">
      <div className="courses-heading">
        <h2>Exceptional Dining & Memorable Celebrations</h2>
        <p>"Celebrate life's special moments in our grand banquet hall, equipped to
host weddings, conferences, and events. With state-of-the-art facilities,
we ensure every occasion is extraordinary."</p>
      </div>
      <div className="courses-offer">
        {courses.map((course, index) => (
          <div className="course-card" key={index}>
            <div className="card-content">
              <div className="background-image" style={{ backgroundImage: `url(${course.image})` }}></div>
              <div className="course-info">
                <h3 className="course-title">{course.title}</h3>
                <p className="course-description">{course.description}</p>
                {/* <a href={course.link} className="course-button">Learn More</a> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BanquiteFacilites;
